import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GlobalErrorsService } from '@core/http/global-errors.service';

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);
  private readonly globalErrorsService = inject(GlobalErrorsService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!this.globalErrorsService.isInterceptorEnabledFor(request, error)) {
          return throwError(() => error);
        }

        this.handleError(error);
        return EMPTY;
      }),
    );
  }

  private handleError(error: HttpErrorResponse): void {
    console.error('HTTP Error:', error);

    this.router
      .navigate(['/error'], {
        queryParams: {
          statusCode: error.status,
          errorCode: error.error?.ErrorCode,
        },
      })
      .catch((navError) => console.error('Navigation failed:', navError));
  }
}
